import { ServiceApi } from '../../utils/auth'

export default {
  namespaced: true,
  state: {
    advertising: [],
    advertisingService: []
  },
  getters: {
    getAdvertising: state => state.advertising,
    getAdvertisingService: state => state.advertisingService

  },
  mutations: {
    setAdvertising(state, payload) {
      state.advertising = payload.data;
    },
    setAdvertisingService(state, payload) {
      state.advertisingService = payload.data;
    }
  },
  actions: {
    async fetchAdvertising({ commit }, payload) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await ServiceApi.get('api/advertising-service', payload);
        commit("setAdvertising", res.data);
        return res.data;
      } catch (error) {
        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async createOrUpdate({ commit, dispatch }, payload) {
      commit("config/SET_OVERLAY", true, { root: true });
      const formData = new FormData();
      formData.append("name", payload.name);
      formData.append("description", payload.description);
      formData.append("image", payload.image);
      formData.append("amount", payload.amount);
      formData.append("price", payload.price);
      formData.append("whp_price", payload.whp_price);
      formData.append("currency_id", payload.currency_id.id);
      formData.append("duration", payload.duration);
      formData.append("max_ads_creation", payload.max_ads_creation);

      try {
        if (!payload.id) {
          const resp = await ServiceApi.post("api/advertising-service", formData);
          return resp;
        } else {
          formData.append("_method", "PUT");
          const res = await ServiceApi.post(`api/advertising-service/${payload.id}`, formData);
          return res;
        }
      } catch (error) {

        throw error;
      } finally {
        dispatch('fetchAdvertising');
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async delete({ commit, dispatch }, id) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res/* A template literal. It allows you to create a string with multiple lines. */
          = await ServiceApi.delete(`api/advertising-service/${id}`);
        dispatch('fetchAdvertising');
        return res.data
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    // SERVICE ADVERTISING

    async fetchAdvertisingService({ commit }, payload) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await ServiceApi.get(`/api/advertising`);
        commit("setAdvertisingService", res.data);
        return res.data;
      } catch (error) {
        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },

    // APPROVE ADVERTISING
    async approveAdvertising({ commit }, payload) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await ServiceApi.post('/api/advertising/approve', payload);
        return res.data;
      } catch (error) {
        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },

  }
};
